import { InfoInput } from '@p2p/components';
import { TGetOrderResponse } from '@p2p/services';

import styles from './AccountNumberInfoItems.module.scss';
import { getRequisiteRows } from './requisiteRows';

type AccountNumberInfoItemsProps = {
  order: TGetOrderResponse;
  randomId: string;
};

export const AccountNumberInfoItems = ({ order, randomId }: AccountNumberInfoItemsProps) => (
  <div className={styles.infoItemsBox}>
    {getRequisiteRows(order, randomId).map((row) => (
      <InfoInput label={row.label} value={row.value} canCopy={row.canCopy} key={row.label} />
    ))}
  </div>
);
